module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../node_modules/coffee-loader/index.js!./nl-BE.coffee"));
	}, "locale/nl-BE");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=locale/[name]!./app/locale/nl-BE.coffee
// module id = 289
// module chunks = 100